/* APIRoutes
* Use create/retrieve/update/delete keywords for api prop name and follow the module screen hierarchy.
* if same api is used for multiple operations, define it once with the prop name in short form
*  (e.g cu, cd,cud, crud)
*/

export const APIRoutes = {
    creditNotes: {
        context: {
            action: 'CreditNotes/CreditNote/:WorkCreditNoteId/Context',
        },
        invoiceLines: {
            retrieve: 'CreditNotes/CreditNote/:WorkCreditNoteId/InvoiceLines',
            load: 'CreditNotes/CreditNote/:WorkCreditNoteId/LoadInvoiceLines',
        },
        lines: {
            retrieve: 'CreditNotes/CreditNote/:WorkCreditNoteId/Lines',
            update: 'CreditNotes/CreditNote/:WorkCreditNoteId/Line/:WorkCreditNoteLineId/UpdateGridLine',
            delete: 'CreditNotes/CreditNoteLine/:WorkCreditNoteLineId',
            calculate: 'CreditNotes/CreditNote/:WorkCreditNoteId/Line/:WorkCreditNoteLineId/CalculateGridLine',
            lineDetails: {
                retrieve: 'CreditNotes/CreditNoteLine/:WorkCreditNoteLineId',
                update: 'CreditNotes/CreditNoteLine/:WorkCreditNoteLineId/UpdateLineDetails',
                calculate: 'CreditNotes/CreditNoteLine/:WorkCreditNoteLineId/CalculateLineDetails',
                cancel: 'CreditNotes/CreditNoteLine/:WorkCreditNoteLineId/CancelLineDetails'
            }
        },
        fastLine: {
            calculate: 'CreditNotes/CreditNote/:WorkCreditNoteId/CalculateFastLine',
            create: 'CreditNotes/CreditNote/:WorkCreditNoteId/CreateFastLine'
        },
        restockingCalculator: {
            calculateRestockingCharge: 'CreditNotes/CreditNote/:WorkCreditNoteId/CalculateRestockCharge',
            calculate: 'CreditNotes/CreditNote/:WorkCreditNoteId/RestockChargeCalculator'
        },
        kitComponents: {
            load: 'CreditNotes/CreditNoteLine/:WorkCreditNoteLineId/Component/LoadComponents',
            summary: 'CreditNotes/CreditNoteLine/:WorkCreditNoteLineId/Summary',
            line: {
                retrieve: 'CreditNotes/CreditNoteLine/:WorkCreditNoteLineId/GetComponents',
                delete: 'CreditNotes/Component/:ComponentId',
                update: 'CreditNotes/CreditNoteLine/:WorkCreditNoteLineId/Component/UpdateComponentGridLine',
                calculate: 'CreditNotes/CreditNoteLine/:WorkCreditNoteLineId/Component/CalculateComponentGridLine',
            },
            fastline: {
                calculate: 'CreditNotes/CreditNoteLine/:WorkCreditNoteLineId/Component/CalculateComponentFastLine',
                create: 'CreditNotes/CreditNoteLine/:WorkCreditNoteLineId/Component/CreateComponentFastLine',
            },
            details: {
                retrieve: 'CreditNotes/Component/:ComponentId',
                update: 'CreditNotes/CreditNoteLine/:WorkCreditNoteLineId/Component/UpdateComponentLineDetail',
                calculate: {
                    componentLineDetail: 'CreditNotes/CreditNoteLine/:WorkCreditNoteLineId/Component/CalculateComponentLineDetail',
                }
            }
        },
        cancel: 'CreditNotes/CreditNote/:WorkCreditNoteId/Cancel',
        process: 'CreditNotes/CreditNote/:WorkCreditNoteId/Process',
        processConfirmation: 'CreditNotes/CreditNote/:WorkCreditNoteId/ProcessConfirmation',
        notes: 'CreditNotes/CreditNote/:WorkCreditNoteId/Notes',
        park: 'CreditNotes/CreditNote/:WorkCreditNoteId/Park',
        recall: 'CreditNotes/RetrieveParkedCreditNotes',
        lineDelete: 'CreditNotes/CreditNoteLine/:WorkCreditNoteLineId',
        summary: {
            retrieve: 'CreditNotes/CreditNote/:WorkCreditNoteId/Summary'
        },
        details: 'CreditNotes/CreditNote/:WorkCreditNoteId/Details',
    },
};
